import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';

import { AuthService } from '@app/service/auth.service';
import { HMemberService } from '@home/service/member.service';
import { CommonService } from '@app/service/common.service';
import { UtilService } from '@app/service/util.service';
import { Globals } from '@app/service/globals.service';
import { BoardService } from '@app/home/service/board.service';

import { O2OZCMS } from '@app/components/o2oz-cms/o2oz-cms.component';

import { ToastrService } from 'ngx-toastr';
import { concatMap } from 'rxjs/operators';

@Component({
  selector: 'app-board',
  templateUrl: './board.component.html',
  styleUrls: ['./board.component.scss']
})
export class BoardComponent extends O2OZCMS implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/

  public isSelectOnA: boolean; //selectbox on
  public isSelectTxtA = '전체'; // selectbox txt

  public isSelectOnB: boolean; //selectbox on
  public isSelectTxtB = '제품명'; // selectbox txt

  public isSelectOnB1: boolean; //selectbox on
  public isSelectTxtB1 = '1차 선택하세요.'; // selectbox txt

  public isSelectOnB2: boolean; //selectbox on
  public isSelectTxtB2 = '2차 선택하세요.'; // selectbox txt

  public params: any = {
    board_id: 'notice',
    board_type: 'A',
    searchGroup: '',
    searchText: '',
    category1: '',
    category1_index: -1,
    category2: '',
    category2_index: -1,
    company: '',
    type: '',   // 리스트, 내용보기, 쓰기, 수정 : list, view, write, modify
  };

  public boardInfo: any = {};
  public memberInfo: any = {};
  public data: any = [];
  public totalCount: any = 0;
  public category: any = [];

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    router: Router,
    commonService: CommonService,
    activatedRoute: ActivatedRoute,
    toastrService: ToastrService,
    private authService: AuthService,
    private memberService: HMemberService,
    private globals: Globals,
    private boardService: BoardService
  ) {
    // 상위 클래스에 router 전달
    super(router, commonService, activatedRoute, toastrService);
  }

  /*******************************************************************************
    설  명 : 데이터 초기화
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngOnInit() {
    this.isSelectOnA = false;

    this.activatedRoute.queryParams.subscribe(params => {
      this.params.board_id = ( typeof params.board_id == 'undefined' || params.board_id == '' ) ? 'notice' : params.board_id;
      this.params.group_id = ( typeof params.group_id == 'undefined' || params.group_id == '' ) ? '' : params.group_id;
      this.params.type = ( typeof params.type == 'undefined' || params.type == '' ) ? 'list' : params.type;
      this.params.row = ( typeof params.row == 'undefined' || params.row == '' ) ? '15' : params.row;
      this.params.no = ( typeof params.no == 'undefined' || params.no == '' ) ? '1' : params.no;
      this.params.group = ( typeof params.group == 'undefined' || params.group == '' ) ? 'subject' : params.group;
      this.params.text = ( typeof params.text == 'undefined' || params.text == '' ) ? '' : params.text;

      // AHRI인증 컨설팅게시판
      if (params.board_id === 'ahriconsult') {
        this.params.type = 'write';
        return true;
      }

      this.getBoardInfo( this.params.board_id );
      this.memberInfo$.subscribe( data => {
        if ( typeof data['memNo'] == 'undefined' )  {
          return false;
        } else {
          this.memberInfo = data;
        }
      });

    });
  }

  /*******************************************************************************
    설  명 : 뷰 처리 완료 후
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngAfterViewInit() {
    // indicator 표시 숨김
    setTimeout (() => {
      this.globals.indicator.next(true);
    });
  }

  /*******************************************************************************
    설  명 : 게시판 정보 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getBoardInfo( board_id: any ) {
    this.boardService.getBoardInfoId( this.params.board_id ).then( response => {
      if( response.ResultCode ) {
        this.boardInfo = response.data;

        // e카탈로그일 경우 카테고리 가져오기
        if( this.boardInfo.board_type_code == '6000' ) {
          this.getEBookCategory();
        }

        // 게시글 리스트 가져오기
        this.getBoardList();

      } else {
        this.globals.indicator.next(false);

        this.toastrService.error( "존재하지 않는 게시판입니다.", "게시판 에러" );

        this.router.navigate( ['/main'] );
        return false;
      }
    });
  }

  /*******************************************************************************
    설  명 : e카탈로그 카테고리 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getEBookCategory() {
    this.boardService.getEBookCategory().then( response => {
      if( response.ResultCode ) {
        this.category = response.data;
      } else {
        this.category = [];
      }
    });
  }

  /*******************************************************************************
    설  명 : 게시판 정보 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getBoardList() {
    this.boardService.getBoardList( this.params ).then( response => {

      if( response.ResultCode ) {
        this.data = response.data;
        this.totalCount = response.total;
      } else {
        this.data = [];
        this.totalCount = 0;
      }

      this.globals.indicator.next(false);
    });
  }

  /*******************************************************************************
    설  명 : 검색 조건 클릭
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  selectSearchGroup( group ) {
    if( group == '' )
      this.isSelectTxtA = '전체';
    else if( group == 'subject' )
      this.isSelectTxtA = '제목';
    else if( group == 'contents' )
      this.isSelectTxtA = '내용';
    else if( group == 'writer' )
      this.isSelectTxtA = '등록자';

    this.params.searchGroup = group;
  }

  /*******************************************************************************
    설  명 : 검색 조건 초기화
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  initSearch() {
    this.params.searchGroup = '';
    this.params.searchText = '';
    this.isSelectTxtA = '전체';

    this.getBoardList();
  }

  /*******************************************************************************
    설  명 : 엔터 입력 시 검색
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  searchList( event ) {
    if( event.key == 'Enter' ) {
      this.getBoardList();
    }
  }

  /*******************************************************************************
    설  명 : 1차 카테고리 선택 시 처리
    입력값 : item
    리턴값 : 없음
  *******************************************************************************/
  selectCategory1( item, index ) {
    this.isSelectTxtB1 = item.directory_name;
    this.isSelectTxtB2 = '2차 선택하세요.';
    this.params.category1 = item.seq;
    this.params.category1_index = index;
  }

  /*******************************************************************************
    설  명 : 2차 카테고리 선택 시 처리
    입력값 : item
    리턴값 : 없음
  *******************************************************************************/
  selectCategory2( item, index ) {
    this.isSelectTxtB2 = item.directory_name;
    this.params.category2 = item.seq;
    this.params.category2_index = index;
  }

  /*******************************************************************************
    설  명 : 제품명, 회사명 검색
    입력값 : item
    리턴값 : 없음
  *******************************************************************************/
  selectCategory3( group ) {
    if( group == 'subject' ) this.isSelectTxtB = '제품명'
    else this.isSelectTxtB = '회사명'
    this.params.searchGroup = group;
  }

  /*******************************************************************************
    설  명 : 1차 카테고리 선택 시 처리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  initCategory1() {
    this.isSelectTxtB1 = '1차 선택하세요.';
    this.isSelectTxtB2 = '2차 선택하세요.';
    this.params.category1 = '';
    this.params.category1_index = -1;
    this.params.category2 = '';
    this.params.category2_index = -1;
  }

  /*******************************************************************************
    설  명 : 2차 카테고리 선택 시 처리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  initCategory2() {
    this.isSelectTxtB2 = '2차 선택하세요.';
    this.params.category2 = '';
    this.params.category2_index = -1;
  }

  /*******************************************************************************
    설  명 : e카탈로그 초기화
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  initSearchECatalogs() {
    this.isSelectTxtB1 = '1차 선택하세요.';
    this.isSelectTxtB2 = '2차 선택하세요.';
    this.params.category1 = '';
    this.params.category1_index = -1;
    this.params.category2 = '';
    this.params.category2_index = -1;
    this.params.company = '';

    this.isSelectTxtB = '제품명';
    this.params.searchGroup = 'subject';
    this.params.searchText = '';

    this.getBoardList();
  }

  /*******************************************************************************
    설  명 : 서브메뉴 링크
    입력값 : item = 메뉴 array
    리턴값 : 없음
  *******************************************************************************/
  goLink( menu ) {
    let href = menu.link_url;
    let boardId = menu.board_id;
    let menuIndex = menu.seq;

    if (href === '') {
      let result = false;
      const link = function getURL(item) {
        if (item.link_url === '' && item.board_id === '') {
          for (const element of item.children) {
            getURL(element);
            if (result) {
              return false;
            }
          }
        } else {
          href = item.link_url;
          boardId = item.board_id;
          menuIndex = item.seq;
          result = true;
        }
      };
      link(menu);
    }

    if ( boardId === '' ) {
      this.router.navigate([ href ], { queryParams: { menu_seq: menuIndex }});
    } else {
      this.router.navigate([ (href !== '' ? href : '/board/list') ], { queryParams: { board_id: boardId } });
    }
  }

}
